import type { IReportFilter } from './ReportFilter.interface';

export default class ReportFilter implements IReportFilter {
  nest: string;
  bool: string;
  term: string;
  type: string;
  value: any;

  static build = (data: IReportFilter) => new ReportFilter(data);
  static blank = () => new ReportFilter();

  /**
   * Constructor
   * @param {IReportFilter} data
   */
  constructor(data?: IReportFilter) {
    this.nest = data?.nest || undefined;
    this.bool = data?.bool || undefined;
    this.term = data?.term || undefined;
    this.type = data?.type || undefined;
    this.value = data?.value || undefined;
  }
}
